const MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const toSafeDate = (value) => (value instanceof Date && !Number.isNaN(value.getTime()) ? value : new Date());

export const getBookingWindowLabel = (referenceDate = new Date()) => {
  const safeDate = toSafeDate(referenceDate);
  const startMonth = safeDate.getMonth();
  const startYear = safeDate.getFullYear();

  const endDate = new Date(startYear, startMonth + 3, 1);
  const endMonth = endDate.getMonth();
  const endYear = endDate.getFullYear();

  if (startYear === endYear) {
    return `${MONTH_LABELS[startMonth]}–${MONTH_LABELS[endMonth]} ${startYear}`;
  }

  return `${MONTH_LABELS[startMonth]} ${startYear}–${MONTH_LABELS[endMonth]} ${endYear}`;
};
